import { ServiceService } from './services.service';
import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';
import * as ServiceActions from './services.action';
import * as ServiceModels from '../../models/services/service';
import { ServiceSearchModel } from '../../models/services/serviceSearch';
import { BannerService } from '../../shared/services/banner.service';
import { SaveState } from '../../models/commonModels';
import { HelperService } from '../../../../src/app/services/helper/helper.service';
import * as Models from '../../models/commonModels';
import { saveAs } from "file-saver";
import { StorageService } from '../../shared/services/storage.service';

export interface ServiceStateModel {
  ServiceSave: SaveState;
  ServiceList: ServiceModels.ServiceListModel;
  Service: ServiceModels.ServiceModel;
  ServiceSearch: ServiceSearchModel;
  ServiceTypeDictionary: ServiceModels.ServiceTypeDictionaryListModel;


  CustomerGarageServicePriceList: Models.Response<ServiceModels.CustomerGarageServicePriceModel[]>;
  CustomerGarageServicePriceListSearch: ServiceModels.CustomerGarageServicePriceSearchModel;
  GetGarageServicePriceExcelReportLoading: boolean;
  GetGarageServicePricePdfReportLoading: boolean;
  ImportGarageServicePriceStatus: boolean;
}

class DictionaryKeys {
  public static readonly ServiceTypeDictionary = "ServiceTypeDictionary";
}

@State<ServiceStateModel>({
  name: 'serviceState',
  defaults: {
    ServiceList: null,
    ServiceSave: null,
    Service: null,
    ServiceSearch: null,
    ServiceTypeDictionary: null,
    CustomerGarageServicePriceList: null,
    CustomerGarageServicePriceListSearch: null,
    GetGarageServicePriceExcelReportLoading: null,
    GetGarageServicePricePdfReportLoading: null,
    ImportGarageServicePriceStatus: null,
  }
})

@Injectable()

export class ServiceState {

  constructor(
    private helperService: HelperService,
    private serviceService: ServiceService,
    private bannerService: BannerService,
    private storageService: StorageService
  ) { }

  @Selector()
  static ServiceList(state: ServiceStateModel) {
    return state.ServiceList;
  }

  @Selector()
  static ServiceSave(state: ServiceStateModel) {
    return state.ServiceSave;
  }

  @Selector()
  static ServiceSearch(state: ServiceStateModel) {
    return state.ServiceSearch;
  }

  @Selector()
  static ServiceTypeDictionary(state: ServiceStateModel) {
    return state.ServiceTypeDictionary;
  }

  @Selector()
  static GetCustomerGarageServicePriceList(state: ServiceStateModel) {
    return state.CustomerGarageServicePriceList;
  }

  @Selector()
  static GetGarageServicePriceReportLoading(state: ServiceStateModel) {
    return state.GetGarageServicePriceExcelReportLoading;
  }

  @Selector()
  static GetGarageServicePriceExcelReportLoading(state: ServiceStateModel) {
    return state.GetGarageServicePriceExcelReportLoading;
  }

  @Selector()
  static GetGarageServicePricePdfReportLoading(state: ServiceStateModel) {
    return state.GetGarageServicePricePdfReportLoading;
  }

  @Selector()
  static ImportGarageServicePriceStatus(state: ServiceStateModel) {
    return state.ImportGarageServicePriceStatus;
  }


  @Action(ServiceActions.GetServiceTypeDictionary)
  getServiceTypeDictionary(
    context: StateContext<ServiceStateModel>,
    action: ServiceActions.GetServiceTypeDictionary
  ) {

    const errorMessage = 'Błąd pobierania słownika typów usług.';

    let storageKey = DictionaryKeys.ServiceTypeDictionary;

    context.setState(
      patch({
        ServiceTypeDictionary: this.storageService.getItemJSON(storageKey)
      })
    );

    const state = context.getState();

    if (!state.ServiceTypeDictionary) {
      this.serviceService.getServiceTypeDictionary().subscribe((ret) => {
        if (ret.Success) {

          context.setState(
            patch({
              ServiceTypeDictionary: ret
            })
          );

          this.storageService.setItemJSON(storageKey, ret);

          return ret;

        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },
        (error) => {
          this.helperService.SaveException('ServiceActions.GetServiceTypeDictionary', error);

          this.bannerService.error(errorMessage);
        });
    }
  }


  @Action(ServiceActions.GetServiceList)
  getServiceList(
    context: StateContext<ServiceStateModel>,
    action: ServiceActions.GetServiceList
  ) {

    const errorMessage = 'Błąd pobierania listy katalogów.';

    context.setState(
      patch({
        ServiceList: null
      })
    );

    this.serviceService.getList(action.Search).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            ServiceList: ret
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('ServiceActions.GetServiceList', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(ServiceActions.GetService)
  getService(
    context: StateContext<ServiceStateModel>,
    action: ServiceActions.GetService
  ) {

    const errorMessage = 'Błąd pobierania szczegółów katalogu .';

    context.setState(
      patch({
        Service: null
      })
    );

    this.serviceService.get(action.ServiceId).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            Service: ret.Item
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('ServiceActions.GetService', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(ServiceActions.Refresh)
  Refresh(
    context: StateContext<ServiceStateModel>,
    action: ServiceActions.Refresh
  ) {

    const errorMessage = 'Błąd pobierania szczegółów katalogu.';

    this.serviceService.get(action.Service.ServiceId).subscribe((ret) => {
      if (ret.Success) {

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('ServiceActions.Refresh', error);

        this.bannerService.error(errorMessage);
      });
  }


  @Action(ServiceActions.SetServiceSearch)
  setServiceSearch(
    context: StateContext<ServiceStateModel>,
    action: ServiceActions.SetServiceSearch
  ) {

    action.Search.CurrentPage = 1;

    context.setState(
      patch({
        ServiceSearch: action.Search
      }));

    context.dispatch(new ServiceActions.GetServiceList(action.Search));
  }

  @Action(ServiceActions.SetServiceListPage)
  setDepositeListPage(
    context: StateContext<ServiceStateModel>,
    action: ServiceActions.SetServiceListPage
  ) {

    context.setState(
      patch({
        ServiceSearch: action.Search
      }));

    context.dispatch(new ServiceActions.GetServiceList(action.Search));
  }

  @Action(ServiceActions.ResetServiceSearch)
  resetDepositeSearch(
    context: StateContext<ServiceStateModel>
  ) {

    const state = context.getState();

    const serviceSearch = new ServiceSearchModel();

    serviceSearch.ItemsPerPage = state.ServiceSearch.ItemsPerPage;

    context.setState(
      patch({
        ServiceSearch: serviceSearch
      }));

    context.dispatch(new ServiceActions.GetServiceList(state.ServiceSearch));
  }

  @Action(ServiceActions.DeleteServiceItem)
  deleteServiceItem(
    context: StateContext<ServiceStateModel>,
    action: ServiceActions.DeleteServiceItem
  ) {

    const errorMessage = 'Błąd podczas usuwania usługi.';

    context.setState(
      patch({
        ServiceSave: null
      })
    );

    this.serviceService.delete(action.ServiceId).subscribe((ret) => {
      if (ret === action.ServiceId) {
        context.setState(
          patch({
            ServiceSave: new SaveState(action.ServiceId, true)
          })
        );

        return ret;

      } else {
        this.bannerService.error(errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('ServiceActions.DeleteServiceItem', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(ServiceActions.DuplicateServiceItem)
  duplicateServiceItem(
    context: StateContext<ServiceStateModel>,
    action: ServiceActions.DeleteServiceItem
  ) {

    const errorMessage = 'Błąd podczas duplikowania usługi.';

    context.setState(
      patch({
        ServiceSave: null
      })
    );

    this.serviceService.duplicate(action.ServiceId).subscribe((ret) => {
      if (ret === action.ServiceId) {
        context.setState(
          patch({
            ServiceSave: new SaveState(action.ServiceId, true)
          })
        );

        return ret;

      } else {
        this.bannerService.error(errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('ServiceActions.DuplicateServiceItem', error);

        this.bannerService.error(errorMessage);
      });
  }


  @Action(ServiceActions.Insert)
  insert(
    context: StateContext<ServiceStateModel>,
    action: ServiceActions.Insert
  ) {
    const errorMessage = 'Błąd zapisu nowej usługi.';

    context.setState(
      patch({
        ServiceSave: null
      })
    );

    this.serviceService.insertNew(action.Service).subscribe(
      ret => {
        this.bannerService.success('Dodano nową usługę.');

        context.setState(
          patch({
            ServiceSave: new SaveState(null, true)
          })
        );
      },

      (error) => {
        context.setState(
          patch({
            ServiceSave: new SaveState(null, false)
          })
        );

        this.helperService.SaveException('PricelistDetailActions.Insert', error);
        this.bannerService.error(`${errorMessage}`);
      },
      () => { });
  }


  @Action(ServiceActions.Set)
  set(
    context: StateContext<ServiceStateModel>,
    action: ServiceActions.Insert
  ) {
    const errorMessage = 'Błąd zapisu zmian w katalogu usług.';

    context.setState(
      patch({
        ServiceSave: null
      })
    );


    this.serviceService.set(action.Service).subscribe(
      ret => {
        this.bannerService.success('Zapisano zmiany katalogu usług.');

        context.setState(
          patch({
            ServiceSave: new SaveState(null, true)
          })
        );
      },

      (error) => {
        context.setState(
          patch({
            ServiceSave: new SaveState(null, false)
          })
        );


        this.helperService.SaveException('PricelistDetailActions.Set', error);

        this.bannerService.error(`${errorMessage}`);
      },
      () => { });
  }

  @Action(ServiceActions.SetNotDefinePriceServiceCommission)
  setNotDefinePriceServiceCommission(
    context: StateContext<ServiceStateModel>,
    action: ServiceActions.SetNotDefinePriceServiceCommission
  ) {
    const errorMessage = 'Błąd zapisu prowizj dla usług z ceną nieokreśloną.';

    context.setState(
      patch({
        ServiceSave: null
      })
    );


    this.serviceService.setCommision(action.Commision).subscribe(
      ret => {
        this.bannerService.success('Zapisano zmiany prowizj dla usług z ceną nieokreśloną .');

        context.setState(
          patch({
            ServiceSave: new SaveState(null, true)
          })
        );
      },

      (error) => {
        context.setState(
          patch({
            ServiceSave: new SaveState(null, false)
          })
        );


        this.helperService.SaveException('ServiceActions.SetNotDefinePriceServiceCommission', error);

        this.bannerService.error(`${errorMessage}`);
      },
      () => { });
  }

  @Action(ServiceActions.DisposeSearch)
  disposeSearch(
    context: StateContext<ServiceStateModel>
  ) {

    context.setState(
      patch({
        ServiceSearch: null
      }));
  }



  @Action(ServiceActions.GetCustomerGarageServicePriceList)
  getCustomerGarageServicePriceList(
    context: StateContext<ServiceStateModel>,
    action: ServiceActions.GetServiceList
  ) {

    const errorMessage = 'Błąd pobierania listy cenników';

    context.setState(
      patch({
        CustomerGarageServicePriceList: null
      })
    );

    this.serviceService.getCustomerGarageServicePriceList(action.Search).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            CustomerGarageServicePriceList: ret
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('ServiceActions.GetCustomerGarageServicePriceList', error);

        this.bannerService.error(errorMessage);
      });
  }


  @Action(ServiceActions.SetCustomerGarageServicePriceSearch)
  setCustomerGarageServicePriceSearch(
    context: StateContext<ServiceStateModel>,
    action: ServiceActions.SetCustomerGarageServicePriceSearch
  ) {

    action.Search.CurrentPage = 1;

    context.setState(
      patch({
        CustomerGarageServicePriceListSearch: action.Search
      }));

    context.dispatch(new ServiceActions.GetCustomerGarageServicePriceList(action.Search));
  }

  @Action(ServiceActions.SetCustomerGarageServicePriceListPage)
  setCustomerGarageServicePriceListPage(
    context: StateContext<ServiceStateModel>,
    action: ServiceActions.SetCustomerGarageServicePriceListPage
  ) {

    context.setState(
      patch({
        CustomerGarageServicePriceListSearch: action.Search
      }));

    context.dispatch(new ServiceActions.GetCustomerGarageServicePriceList(action.Search));
  }

  @Action(ServiceActions.ResetCustomerGarageServicePriceList)
  resetCustomerGarageServicePriceList(
    context: StateContext<ServiceStateModel>
  ) {

    const state = context.getState();

    const serviceSearch = new ServiceModels.CustomerGarageServicePriceSearchModel();

    serviceSearch.ItemsPerPage = state.ServiceSearch.ItemsPerPage;

    context.setState(
      patch({
        CustomerGarageServicePriceListSearch: serviceSearch
      }));

    context.dispatch(new ServiceActions.GetCustomerGarageServicePriceList(state.CustomerGarageServicePriceListSearch));
  }

  @Action(ServiceActions.SetCustomerGarageServicePrice)
  setCustomerGarageServicePrice(
    context: StateContext<ServiceStateModel>,
    action: ServiceActions.SetCustomerGarageServicePrice
  ) {
    const errorMessage = 'Błąd zapisu cennika.';

    this.serviceService.setCustomerGarageServicePrice(action.SaveServiceList).subscribe(
      ret => {
        this.bannerService.success('Cennik został zapsany.');
        action.SaveServiceList.End();
      },

      (error) => {
        action.SaveServiceList.End();

        this.helperService.SaveException('ServiceActions.SetCustomerGarageServicePrice', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(ServiceActions.GetGarageServicePriceExcelReport)
  getGarageServicePriceReport(
    context: StateContext<ServiceStateModel>,
    action: ServiceActions.GetGarageServicePriceExcelReport
  ) {
    function patchContext(loading: boolean) {
      context.setState(
        patch({
          GetGarageServicePriceExcelReportLoading: loading,
        })
      );
    }

    patchContext(true);
    const fileName = "Serwisy-cennik";
    this.bannerService.info(
      `Rozpoczęto generowanie pliku raportu ${fileName}, proszę czekać ...`,
      "Export danych"
    );

    this.serviceService.getGarageServicePriceExcelReport(action.Search).subscribe(
      (res) => {
        const file = new File(
          [res],
          `${fileName}-${this.helperService.TimeStamp()}.xlsx`,
          {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          }
        );
        saveAs(file);
        patchContext(false);
      },
      (res) => {
        patchContext(false);
        this.bannerService.error(`Błąd pobierania raportu: ${fileName}`);
      },
      () => {
        patchContext(false);
        this.helperService.consoleLog(
          "@Action(GarageActions.GetGarageReportFiltered)"
        );
      }
    );
  }


  @Action(ServiceActions.GetGarageServicePricePdfReport)
  getGarageServicePricePdfReport(
    context: StateContext<ServiceStateModel>,
    action: ServiceActions.GetGarageServicePriceExcelReport
  ) {
    function patchContext(loading: boolean) {
      context.setState(
        patch({
          GetGarageServicePricePdfReportLoading: loading,
        })
      );
    }

    patchContext(true);
    const fileName = "Serwisy-cennik";
    this.bannerService.info(
      `Rozpoczęto generowanie pliku raportu ${fileName}, proszę czekać ...`,
      "Export danych"
    );

    this.serviceService.getGarageServicePricePdfReport(action.Search).subscribe(
      (res) => {
        const file = new File(
          [res],
          `${fileName}-${this.helperService.TimeStamp()}.pdf`,
          {
            type:
              "application/pdf",
          }
        );
        saveAs(file);
        patchContext(false);
      },
      (res) => {
        patchContext(false);
        this.bannerService.error(`Błąd pobierania raportu: ${fileName}`);
      },
      () => {
        patchContext(false);
        this.helperService.consoleLog(
          "@Action(ServiceActions.GetGarageServicePricePdfReport)"
        );
      }
    );
  }

  @Action(ServiceActions.SetImportGarageServicePriceListStatus)
  SetImportStatus(
    context: StateContext<ServiceStateModel>,
    action: ServiceActions.SetImportGarageServicePriceListStatus
  ) {
    context.setState(
      patch({
        ImportGarageServicePriceStatus: action.Status
      })
    );
  }


  @Action(ServiceActions.ImportGarageServicePriceList)
  Import(
    context: StateContext<ServiceStateModel>,
    action: ServiceActions.ImportGarageServicePriceList
  ) {

    this.bannerService.quickInfo('Rozpoczęto import cenników, proszę czekać.');

    this.serviceService.importGarageServicePrice(action.Data).subscribe(ret => {

      this.helperService.consoleLog(ret.headers);

      const processed = ret.headers.get('x-import-processed');
      const error = ret.headers.get('x-import-error');
      const result = ret.headers.get('x-import-result');
      const message = ret.headers.get('x-import-message');
      const imported = Number(ret.headers.get('x-import-imported'));

      if (result === 'OK') {

        context.dispatch(new ServiceActions.SetImportGarageServicePriceListStatus(true));

        const file = new File([ret.body], `Wynik-Importu-${this.helperService.TimeStamp()}-${action.FileName}`, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        if (imported > 0) {
          this.bannerService.instantSuccess(`Zakończono import pliku <b>${action.FileName}</b><br/><b>Zaimportowano ${imported}</b> pozycji.<br/>Przetworzono <b>${processed}</b> wierszy.<br/>Znaleziono <b>${error}</b> wierszy z błędami.`);
        }
        else {
          this.bannerService.instantMessage(`Zakończono import pliku <b>${action.FileName}</b><br/><b>Nie zaimporotwano żadnych pozycji</b>.<br/>Przetworzono <b>${processed}</b> wierszy.<br/>Znaleziono <b>${error}</b> wierszy z błędami.`);
        }

        saveAs(file);
      } else {

        if (message === 'IMPORT_EXCEPTION_EMPTY_FILE') {
          this.bannerService.instantError(`Zakończono import pliku <b>${action.FileName}</b><br/>Plik przeznaczony do importu jest pusty.`);
        } else if (message === 'IMPORT_EXCEPTION_INVALID_FILE_EXTENSION') {
          this.bannerService.instantError(`Zakończono import pliku <b>${action.FileName}</b><br/>Plik przeznaczony do importu ma niewłaściwe rozszerzenie.`);
        } else if (message === 'IMPORT_EXCEPTION_INVALID_HEDER') {
          this.bannerService.instantError(`Zakończono import pliku <b>${action.FileName}</b><br/>Plik przeznaczony do importu ma niewłaściwy nagłówek.`);
        } else {
          this.bannerService.instantError(`Zakończono import pliku <b>${action.FileName}</b><br/>Wystąpił nieznany błąd podczas przetwarzania pliku.`);
        }
      }
    },
      (error) => {

        this.helperService.SaveException('ServiceActions.ImportGarageServicePriceList', error);

        this.bannerService.error('Błąd importu cennika.');

        context.dispatch(new ServiceActions.SetImportGarageServicePriceListStatus(false));
      },
      () => {
        context.dispatch(new ServiceActions.SetImportGarageServicePriceListStatus(false));
      }
    );
  }

   
  @Action(ServiceActions.SendEmailGarageServicePricePdfReport)
  sendEmailGarageServicePricePdfReport(
    context: StateContext<ServiceStateModel>,
    action: ServiceActions.SendEmailGarageServicePricePdfReport
  ) {
    this.serviceService.sendEmailGarageServicePricePdfReport(action.Search).subscribe(
      (res) => {
        this.bannerService.success(`Raport został wysłany.`);
      },
      (res) => {
        this.bannerService.error(`Błąd wysyłania wiadomości.`);
      },
      () => {
        this.helperService.consoleLog(
          "@Action(ServiceActions.SendEmailGarageServicePricePdfReport)"
        );
      }
    );
  }

  @Action(ServiceActions.ClearCustomerGarageServicePrice)
  clearCustomerGarageServicePrice(
    context: StateContext<ServiceStateModel>,
    action: ServiceActions.ClearCustomerGarageServicePrice
  ) {
    const errorMessage = 'Błąd wyłączenia cennika.';

    this.serviceService.clearCustomerGarageServicePrice(action.Search).subscribe(
      ret => {
        this.bannerService.success('Cennik został wyłączony.');
        action.Search.End();
      },

      (error) => {
        action.Search.End();

        this.helperService.SaveException('ServiceActions.ClearCustomerGarageServicePrice', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(ServiceActions.GetGarageServicePriceAnalyticExcelReport)
  GetGarageServicePriceAnalyticExcelReport(
    context: StateContext<ServiceStateModel>,
    action: ServiceActions.GetGarageServicePriceExcelReport
  ) {
    function patchContext(loading: boolean) {
      context.setState(
        patch({
          GetGarageServicePriceExcelReportLoading: loading,
        })
      );
    }

    patchContext(true);
    const fileName = "Ceny-uslug-dla-serwisu";
    this.bannerService.info(
      `Rozpoczęto generowanie pliku raportu ${fileName}, proszę czekać ...`,
      "Export danych"
    );

    this.serviceService.GetGarageServicePriceAnalyticExcelReport(action.Search).subscribe(
      (res) => {
        const file = new File(
          [res],
          `${fileName}-${this.helperService.TimeStamp()}.xlsx`,
          {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          }
        );
        saveAs(file);
        patchContext(false);
      },
      (res) => {
        patchContext(false);
        this.bannerService.error(`Błąd pobierania raportu: ${fileName}`);
      },
      () => {
        patchContext(false);
        this.helperService.consoleLog(
          "@Action(GarageActions.GetGarageServicePriceAnalyticExcelReport)"
        );
      }
    );
  }
}
